import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './CSS/UpdatePassword.css';
import axios from "axios";

const UpdatePassword: React.FC = () => {
    const navigate = useNavigate();

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [isCurrentPasswordVisible, setIsCurrentPasswordVisible] = useState(false);
    const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
    const [isConfirmNewPasswordVisible, setIsConfirmNewPasswordVisible] = useState(false);

    const handleCurrentPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => setCurrentPassword(e.target.value);
    const handleNewPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => setNewPassword(e.target.value);
    const handleConfirmNewPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => setConfirmNewPassword(e.target.value);

    const toggleCurrentPasswordVisible = () => setIsCurrentPasswordVisible(!isCurrentPasswordVisible);
    const toggleNewPasswordVisible = () => setIsNewPasswordVisible(!isNewPasswordVisible);
    const toggleConfirmNewPasswordVisible = () => setIsConfirmNewPasswordVisible(!isConfirmNewPasswordVisible);

    const handleSubmit = async () => {
        const subjectToken = localStorage.getItem('subjectToken');
        const accessToken = localStorage.getItem('accessToken');

        if (!subjectToken) {
            console.error('No subject token found');
            return;
        }

        if (newPassword === confirmNewPassword) {
            try {
                const response = await axios.post('https://dev-api.vizelabs.net/api/v1.0/desktop/account/updatePassword', {
                    oldPassword: currentPassword,
                    newPassword: newPassword,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${subjectToken}`,
                    }
                });

                if (response.status === 200) {
                    navigate('/account/profile');
                } else {
                    console.error('Failed to update password:', response.data.message);
                }
            } catch (error) {
                console.error('API error:', error);
            }
        } else {
            console.error('Passwords do not match');
        }
    };


    return (
        <div className="update-password-container">
            <div className="content-area">
                <h2 className="title">Update Your Password</h2>

                <div className="password-container">
                    <label>Current Password</label>
                    <div className="input-container">
                        <input
                            type={isCurrentPasswordVisible ? 'text' : 'password'}
                            placeholder="Enter your current password"
                            value={currentPassword}
                            onChange={handleCurrentPasswordChange}
                        />
                        <button className="show-password" onClick={toggleCurrentPasswordVisible}>
                            {isCurrentPasswordVisible ? 'Hide' : 'Show'}
                        </button>
                    </div>
                </div>

                <div className="password-container">
                    <label>New Password</label>
                    <div className="input-container">
                        <input
                            type={isNewPasswordVisible ? 'text' : 'password'}
                            placeholder="Enter your new password"
                            value={newPassword}
                            onChange={handleNewPasswordChange}
                        />
                        <button className="show-password" onClick={toggleNewPasswordVisible}>
                            {isNewPasswordVisible ? 'Hide' : 'Show'}
                        </button>
                    </div>
                </div>

                <div className="password-container">
                    <label>Confirm New Password</label>
                    <div className="input-container">
                        <input
                            type={isConfirmNewPasswordVisible ? 'text' : 'password'}
                            placeholder="Confirm your new password"
                            value={confirmNewPassword}
                            onChange={handleConfirmNewPasswordChange}
                        />
                        <button className="show-password" onClick={toggleConfirmNewPasswordVisible}>
                            {isConfirmNewPasswordVisible ? 'Hide' : 'Show'}
                        </button>
                    </div>
                </div>

                <button className="submit-button" onClick={handleSubmit}>Update Password</button>
            </div>
        </div>
    );
};

export default UpdatePassword;
